import axiosInstance from "./AxiosConfig";

class ProductCategory {
  async CreateProductCategory(name) {
    
    try {
      const response = await axiosInstance.post("/productcategories/create", {
        name,
      });
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async GetProductCategory() {
    try {
      const response = await axiosInstance.get("/productcategories/get");
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async UpdateProductCategory(id, name) {
    try {
      const response = await axiosInstance.put(
        `/productcategories/update/${id}`,
        { name }
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async DeleteProductCategory(id) {
    try {
      const response = await axiosInstance.delete(
        `/productcategories/delete/${id}`
      );
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
}

export default new ProductCategory();
